import React from 'react';
import classNames from 'classnames';

import Image from 'vibo-ui/Image';

import { ReactComponent as UserIcon } from 'resources/img/svg/common/user.svg';

import { getFullName } from 'services/users/helpers';

import useStyles from '../style';

interface UserImageProps {
  user: Maybe<UserBase>;
  src: string;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  loadMs?: number;
}

const UserImage = ({ user, className, loadMs, onClick, src }: UserImageProps) => {
  const classes = useStyles();
  const alt = !!user ? getFullName(user) : '';

  return (
    <Image
      onClick={onClick}
      src={src}
      alt={alt}
      gradientId={user?._id}
      className={classNames(classes.img, className)}
      debounceLoadMs={loadMs}
    >
      <UserIcon />
    </Image>
  );
};

export default UserImage;
